import React, { Fragment, useRef, useState } from 'react';
import PnIcon from '../../../_PandoNexis/Components/PnIcon';
import QuantityButtons from '../../../_PandoNexis/Components/QuantityButtons';

const MiniCartProduct = ({
    articleNumber,
    product,
    onCartItemIncrement,
    onCartItemDecrement,
    onUpdate,
    onCartItemRemove,
    showStock
}) => {
    const quantityRef = useRef(null);
    const [quantity, setQuantity] = useState(null);
    const updateQuantity = (e) => {
        var newQuantity = e.target.value;
        if (!isNaN(newQuantity)) {
            const quant = parseInt(newQuantity, 10);
            onUpdate(quant);
            setQuantity(quant);
        }
    };

    return (
        <div className="cart__product-row">
            <div className="cart__product-row__image">
                <a href={product.url}><img src={product.image} alt={product.name} /></a>
            </div>
            <div className="cart__product-row__info">
                <div className="cart__split-row">
                    <div className="cart__product-row__articleno">{product.articleNumber}</div>
                    <button className="cart__product-row__remove-button" onClick={onCartItemRemove}><i className="table__icon table__icon--delete" ></i></button>
                </div>
                <div className="cart__split-row">
                    <h3><a href={product.url}>{product.name} {product.nameAdditionalData}</a></h3>
                </div>
                <div className="cart__split-row">
                    <QuantityButtons {...{ onCartItemDecrement, onCartItemIncrement, updateQuantity, quantityRef, inputVal: quantity || product.quantity }} />
                </div>
                {showStock &&
                    <div className="cart__stock-status-info">
                        {product.isInStock ?
                            <Fragment>
                                <link itemProp="availability" href="http://schema.org/InStock" />
                                <div className="cart__stock-status-info"><span className="cart__stock-status-info--in-stock"></span>{product.stockStatusDescription}</div>
                            </Fragment>
                            :
                            <Fragment>
                                <link itemProp="availability" href="http://schema.org/OutOfStock" />
                                <div className="cart__stock-status-info"><span className="cart__stock-status-info--out-of-stock"></span>{product.stockStatusDescription}</div>
                            </Fragment>
                        }
                    </div>
                }
                <div className="cart__product-row__price">
                    {product.campaignPrice ? (
                        <Fragment>
                            <span className="product__campaign-price" dangerouslySetInnerHTML={{ __html: product.campaignPrice }}></span >&nbsp;<span className="product__old-price" dangerouslySetInnerHTML={{ __html: product.price }}></span>
                            <div className="campaign-tag-wrapper">
                                <div className="campaign-tag">
                                    {product.discount}
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <span dangerouslySetInnerHTML={{ __html: product.price }}></span>
                                <div className="campaign-tag-wrapper">
                                    <div className="campaign-tag">
                                        {product.tagText}
                                    </div>
                                </div>
                        </Fragment>)}
                </div>

            </div>
        </div>
    );
};

export default MiniCartProduct